import React, { useEffect, useState } from "react";
import { getUser } from "../../auth";
import DeleteStockForm from "../components/DeleteStockForm";

const URL = process.env.REACT_APP_API_URL;

export default function DeleteStock({ open, onClose }) {
  const [stocks, setStocks] = useState([]);
  const [selectedStocks, setSelectedStocks] = useState([]);
  const [message, setMessage] = useState("");
  const user = getUser();

  useEffect(() => {
    if (!open) return;

    const fetchStocks = async () => {
      try {
        const res = await fetch(`${URL}/api/stock/?empresa_id=${user.empresa_id}`);
        if (!res.ok) throw new Error("Error fetching stocks");
        const data = await res.json();
        setStocks(data);
      } catch (error) {
        console.error("Error fetching stocks:", error);
        setMessage("Error al obtener los stocks.");
      }
    };

    fetchStocks();
  }, [open, user.empresa_id]);

  const handleReset = () => {
    setSelectedStocks([]);
    setMessage("");
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    if (selectedStocks.length === 0) {
      setMessage("Debe seleccionar al menos un producto.");
      return;
    }

    try {
      for (const stock of selectedStocks) {
        await fetch(`${URL}/api/stock/${stock.id}`, {
          method: "DELETE",
          headers: {
            "X-Empresa-Id": user.empresa_id,
          },
        });
      }

      setMessage("Stock eliminado correctamente.");
      handleReset();
      onClose();
    } catch (error) {
      setMessage("Error al eliminar el stock.");
    }
  };

  return (
    <DeleteStockForm
      open={open}
      onClose={onClose}
      onSubmit={handleDelete}
      onReset={handleReset}
      stocks={stocks}
      selectedStocks={selectedStocks}
      setSelectedStocks={setSelectedStocks}
      message={message}
    />
      
  )
}